import {values, any} from 'ramda';

import {isNotNilOrEmpty} from 'shared/web';

export function hasNestedData<T extends Record<string, unknown>>(obj: T) {
  return any((item: T[keyof T]) => {
    if (typeof item === 'object' && isNotNilOrEmpty(item)) {
      return values(item).some(isNotNilOrEmpty);
    }
    return false;
  })(values(obj));
}
